<template>
  <BaseDialog
    v-model="showDialog"
    dialogIcon="mdi-account-edit"
    title="Endre kontaktperson"
    btnActionName="Lagre"
    @action="save"
  >
    <template v-slot>
      <v-form
        v-if="contactpersonData && contactpersonData.person"
        ref="form"
        v-model="valid"
        autocomplete="off"
      >
        <v-text-field
          v-model="contactpersonData.person.firstName"
          class="textFieldError"
          prepend-inner-icon="mdi-account-outline"
          color="primary"
          label="Fornavn (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Fornavn må fylles ut!']"
          required
        ></v-text-field>
        <v-text-field
          v-model="contactpersonData.person.lastName"
          class="textFieldError"
          prepend-inner-icon="mdi-account-outline"
          color="primary"
          label="Etternavn (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Etternavn må fylles ut!']"
          required
        ></v-text-field>
        <v-text-field
          v-model="contactpersonData.person.email"
          class="textFieldError"
          prepend-inner-icon="mdi-email-outline"
          color="primary"
          label="Epost (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Epost må fylles ut!']"
          required
          type="email"
        ></v-text-field>
        <v-text-field
          v-model="contactpersonData.person.mobile"
          class="textFieldError"
          prepend-inner-icon="mdi-cellphone"
          color="primary"
          label="Mobil (Obligatorisk)"
          filled
          autocomplete="off"
          :rules="[(v) => !!v || 'Mobil må fylles ut!']"
          required
          pattern="[0-9]*"
        ></v-text-field>
        <v-text-field
          v-model="contactpersonData.person.title"
          class="textFieldError"
          prepend-inner-icon="mdi-account-hard-hat"
          color="primary"
          label="Tittel"
          filled
          autocomplete="off"
          hide-details
        ></v-text-field>
      </v-form>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions } from "vuex";
import notification from "@/helpers/notification";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  name: "AddContactDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    contactperson: {
      type: Object,
    },
  },
  data() {
    return {
      valid: true,
      contactpersonData: {},
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.contactpersonData = JSON.parse(JSON.stringify(this.contactperson));
      }
    },
  },

  methods: {
    ...mapActions({
      updateProfile: "shared/updateProfile",
    }),
    async save() {
      const isValid = (this as any).$refs?.form?.validate();
      if (isValid) {
        this.$emit("save", this.contactpersonData);
      } else {
        notification.warn("Alle obligatoriske felter må fylles ut!");
      }
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        (this as any).$refs.form.reset();
        this.$emit("input", value);
      },
    },
  },

  components: {
    BaseDialog,
  },
});
</script>

<style lang="scss">
.textFieldError {
  .v-input__control .v-text-field__details {
    margin-bottom: 0px;
  }
}
</style>
